import { useQuery, useMutation, useQueryClient } from 'react-query';
import axiosInstance from '../../config/axiosInstance';
import {
  UpsertCategoryInput,
  UpsertProductInput,
} from '../../config/types/custom/TranslationInput';
import { CategoryModel } from '../../config/types/models';
import { urls } from '../../config/urls';

export const useCategoryDetails = (id: number | string | undefined) => {
  return useQuery(
    ['category', id],
    (): Promise<CategoryModel> =>
      axiosInstance
        .get(`${urls.categories.details}/${id}`)
        .then((res) => res.data),
    {
      enabled: !!id,
    }
  );
};

export const useSaveCategory = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: UpsertCategoryInput) =>
      axiosInstance
        .post(`${urls.categories.details}`, data)
        .then((res) => res.data),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['category', data.id]);
      },
    }
  );
};
